'use client'

import {AdConfigResponse} from '@app/api/ad'
import {defaultConsentState} from '@app/components/ads/constants'
import {AdsClientProvider} from '@gamezop/ads-sdk/ads-client-provider'
import {ConsentState} from '@gamezop/ads-sdk/consent-v2/types'
import {AdUnits, Location, ScriptPriorityType} from '@gamezop/ads-sdk/types'
import {ReactNode} from 'react'

interface Props {
  adConfig: AdConfigResponse
  adScripts: ScriptPriorityType[]
  adUnits: AdUnits
  priceConversion: Record<string, string>
  location: Location
  children: ReactNode
  consentState: ConsentState
}

const AdProviderClient = ({adConfig, adScripts, adUnits, priceConversion, location, children, consentState}: Props) => {
  return (
    <AdsClientProvider
      adConfig={adConfig as any}
      adScripts={adScripts}
      adUnits={adUnits}
      priceConversion={priceConversion}
      location={location}
      product='gamezopComet'
      consentState={consentState}
    >
      {children}
    </AdsClientProvider>
  )
}

export default AdProviderClient
